import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: Theme) => ({
  available: {
    color: theme.palette.success.main,
  },
  unavailable: {
    color: theme.palette.error.main,
  },
  container: {
    width: 'fit-content',
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(2),
    boxShadow: theme.shadows[1],
  },
}));
